import EventEmitter from 'promise-events';
export const AnalyticsEventEmitter = new EventEmitter();
//# sourceMappingURL=AnalyticsEventEmitter.js.map